import axios from 'axios';
import {urlBackend} from '../../main/Util';
import {encryptMethod} from '../EncriptService.js';
axios.defaults.headers.post['Content-Type'] ='application/x-www-form-urlencoded';
axios.defaults.headers.post['Content-Type'] ='application/json;charset=utf-8';
axios.defaults.headers.post['Access-Control-Allow-Origin'] = 'http://localhost:3000';
axios.defaults.headers.post['Cache-control'] = 'no-cache';

export const axiosLogin = axios.create({
    baseURL: urlBackend,
    withCredentials: true   
});

class LoginService{


    constructor(){
        this.apiUrl = '/portal/api'
    }

    authenticateFirstLevel(username, password){
        const requestUrl = `${this.apiUrl}/authenticateFirstLevel`
        const credentials = {
            username: encryptMethod(username),
            password: encryptMethod(password)
        }
        return axiosLogin.post(requestUrl, credentials)
    }

    authenticateSecondLevel(username, password, mfaCode, token){
        const requestUrl = `${this.apiUrl}/authenticateSecondLevel`
        const credentials = {
            username: encryptMethod(username),
            password: encryptMethod(password),
            mfaCode:encryptMethod(mfaCode)
        }
        return axiosLogin.post(requestUrl, credentials)
    }

    recuperarSenha(email){
        const requestUrl = `${this.apiUrl}/recuperarSenha`
        return axiosLogin.post(requestUrl, email)
    }

    resetar(credentials){
        const requestUrl = `${this.apiUrl}/resetar`
        return this.post(requestUrl, credentials);
    }

    clearStorage() {
        sessionStorage.setItem("numeroFatura", '');
        sessionStorage.setItem("produto", "TODOS");
    }

}

export default LoginService;